/* eslint-disable prettier/prettier */
import { createSlice } from '@reduxjs/toolkit'

const allocationSummaryInitialState = {
  selectedProgram: '',
  selectedTypeOfReport: '',
  selectedReceiver: '',
  selectedPlantingCropCycle: '',
  selectedTypeOfPotato: '',
  selectedInputSupplier: '',
  selectedSourceCropCycle: '',
  selectedVariety: '',
  selectedAllocationStatus: '',
  selectedSupplierData: {},
  masters: {},
  programGeneralSettings: {},
  isReloadRequired: false,
}

export const allocationSummarySlice = createSlice({
  name: 'allocationSummary',
  initialState: allocationSummaryInitialState,
  reducers: {
    setFilterData: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    setSelectedReceiver: (state, action) => ({
      ...state,
      selectedRecieverData: action.payload,
    }),
    setMasterMessageData: (state, action) => ({
      ...state,
      masters: action.payload,
    }),
    setProgramGenralSettings: (state, action) => ({
      ...state,
      programGeneralSettings: action.payload,
    }),
    setIsReportReload: (state, action) => ({
      ...state,
      isReloadRequired: action.payload,
    }),
  },
})

export const {
  setFilterData,
  setSelectedReceiver,
  setMasterMessageData,
  setProgramGenralSettings,
  setIsReportReload,
} = allocationSummarySlice.actions

export default allocationSummarySlice.reducer
